import { AxiosResponseType, ReportViewType } from '@/shared/types'
import { REPORT_VIEW } from '@/shared/constants'
import { reportApi, periodontalReportApi } from '@/shared/api'
import { getPeriodontalPDF } from '@/shared/utils'

export const submitReport = async (
  reportType: ReportViewType,
  reportId: number
): AxiosResponseType<any> => {
  if (reportType === REPORT_VIEW.plaqueIndex) {
    return await reportApi.sendEmail(reportId)
  }

  if (reportType === REPORT_VIEW.periodontal) {
    const pdf = await getPeriodontalPDF()

    return await periodontalReportApi.sendEmail(reportId, pdf)
  }
}
